<template>
  <template v-if="routeReady">
    <component :is="routeLayout" v-if="!route.meta?.error" :title="route.meta?.title" :path="route.meta?.path">
      <RouterView v-slot="{ Component, route: activeRoute }">
        <component :is="Component" :key="activeRoute.path" />
      </RouterView>
      <template v-if="route.meta?.extraContent" #extra-content><component :is="route.meta.extraContent" /></template>
    </component>
    <ErrorPage v-else :error="route.meta?.error" />
  </template>
</template>

<script setup lang="ts">
import Page from "@/components/page/Page.vue";
import ErrorPage from "@/pages/ErrorPage.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import EmptyLayout from "./EmptyLayout.vue";

const route = useRoute();

// Before route evaluation is complete, Vue router will just supply an empty route,
// So just render nothing if the route is empty and it's not the same as the homepage
const routeReady = computed(() => {
  if (route.path != "/") return true;

  //Home always has the extraContent property, so if it doesn't have it, we know the router isn't done.
  if (!route.meta.extraContent) return false;

  return true;
});

const routeLayout = computed(() => {
  if (route.meta.layout) return route.meta.layout;

  if (route.meta.layout == false) return EmptyLayout;

  //return default layout
  return Page;
});
</script>
